module.exports = __webpack_public_path__ + "img/slider-11.46f04078.jpg";